import { defineStore } from "pinia";
import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import type { DisplayPermission } from "~/core/models/DisplayPermission.enum";
import LxcError from "~/core/models/LxcError.class";
import type { UserSession } from "~/modules/user/models/UserSession.interface";
import userService from "~/modules/user/services/user.service";
import { logout } from "~/utils/auth.utils";

export const useUserSession = defineStore("userSession", () => {
  const userSession: Ref<UserSession | undefined> = ref();

  const isAuthenticated = ref(false);

  /**
   * Apply retrieve current user to store
   * @param route
   */
  async function setCurrentUser(): Promise<void> {
    const response = await userService.getCurrentUser();

    if (LxcError.check(response)) {
      logout();
    } else {
      userSession.value = response;

      isAuthenticated.value =
        !!userSession.value?.login && userSession.value?.active;

      // Add the permissions of the user to entity for more convenience to restore permissions
      userSession.value.entity.permissions = userSession.value.permissions;

      // Reset the delegation list if the user has no permission "can_read_relation".
      // This is useful in order to deactivate all the feature about delegations and affiliations in frontend side only (mapping removed in src/plugins/acl.ts).
      // This can be kept for belt and braces reason.
      if (!useAcl().can(ACLRoles.CAN_READ_RELATION)) {
        userSession.value.delegations = undefined;
      }
    }
  }

  function setCurrentUserPermissions(permissions: DisplayPermission[]) {
    if (userSession.value) {
      userSession.value.permissions = permissions;
    }
  }

  return {
    userSession,
    setCurrentUser,
    setCurrentUserPermissions,
    isAuthenticated,
  };
});
